import React, { useEffect, useState } from "react";
import Link from "next/link";
import { SearchBar } from "../../components/navmenu/SearchBar/SearchBar";

interface HeaderProps {
  PageBreadCrumbName: string;
  PageName: string;
}

const Header: React.FC<HeaderProps> = ({ PageBreadCrumbName, PageName }) => {
  const [backgroundId, setBackgroundId] = useState<string | null>(null);

  useEffect(() => {
    const min = 1;
    const max = 13;
    const number = Math.floor(Math.random() * (max - min + 1)) + min;
    console.log(`🔄 Setting background ID to bg_${number}`);
    setBackgroundId(`bg_${number}`);
  }, []);

  // Don't render until background ID is set
  if (!backgroundId) return null;

  return (
    <div>
      <section className="header-static-container">
        <div
          className="static-image"
          id={backgroundId}
          data-stellar-background-ratio="0.5"
        >
          <div className="container">
            <div className="row header-text align-items-center">
              <div className="col-md-7 col-sm-12">
                <p className="breadcrumbs">
                  <span className="mr-2">
                    <Link href="/">Home</Link>
                  </span>
                  <span>{PageBreadCrumbName}</span>
                </p>
                <h1 className="mb-3">{PageName}</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SearchBar />
    </div>
  );
};

export default Header;
